import { useEffect } from "react";
import { useMsal } from "@azure/msal-react";
import { EventType } from "@azure/msal-browser";

export function MsalAccountInitializer() {
    const { instance } = useMsal();

    useEffect(() => {
        const callbackId = instance.addEventCallback((event) => {
            if (
                (event.eventType === EventType.LOGIN_SUCCESS ||
                 event.eventType === EventType.ACQUIRE_TOKEN_SUCCESS) &&
                event.payload
            ) {
                const payload = event.payload;
                instance.setActiveAccount(payload.account);
            }
        });

        // Fallback on page reload if an account is already cached
        const active = instance.getActiveAccount();
        if (!active) {
            const allAccounts = instance.getAllAccounts();
            if (allAccounts.length === 1) {
                instance.setActiveAccount(allAccounts[0]);
            }
        }

        return () => {
            if (callbackId) {
                instance.removeEventCallback(callbackId);
            }
        };
    }, [instance]);

    return null;
}
